import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { checkLogin } from "../../utils/functions";
import LoginModal from "../modals/login";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import logsService from "../../services/logServices";
import InvestorActivityEventType from "../../utils/eventTypes";
import { useSelector } from "react-redux";

export default function MobileBottomTab(){
    const [activeTab,setActiveTab] = useState(0);
    const [showLogin,setShowLogin] = useState(false);
    const [showSignUp,setShowSignUp] = useState(false);
    const [showTerms,setShowTerms] = useState(false);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const user = useSelector(state => state.user?.data);

    const normalizePath = (p) => {
        if (!p) return "/";
        const out = p.trim();
        if (out.length > 1 && out.endsWith("/")) return out.slice(0, -1);
        return out;
    };

    const isPathMatch = (currentPath, tabPath) => {
        const cur = normalizePath(currentPath);
        const tab = normalizePath(tabPath);
        if (tab === "/") return cur === "/";
        return cur === tab || cur.startsWith(`${tab}/`);
    };

    const handleClick = (index) =>{
        setActiveTab(index);
        if(tabs[index]){
            navigate(tabs[index].link,{replace:true});
        }
    }
    const tabs = [
        {
            name:"Dashboard",
            link:"/dashboard",
            icon: <DashboardOutlinedIcon fontSize="small" />
        },
        // {
        //     name:"Marketplace",
        //     link:"/marketplace",
        // },
        {
            name:"Portfolio",
            link:"/portfolio",
            icon: <WorkOutlineOutlinedIcon fontSize="small" />,
            event: InvestorActivityEventType.PORTFOLIO_VIEWED
        },
        {
            name:"Wallet",
            link:"/wallet",
            icon: <AccountBalanceWalletOutlinedIcon fontSize="small" />,
            event: InvestorActivityEventType.WALLET_PAGE_VIEWED
        },
        {
            name:"Transactions",
            link:"/transactions",
            icon: <ReceiptLongOutlinedIcon fontSize="small" />,
            event: InvestorActivityEventType.TRANSACTION_PAGE_VIEWED,
        },
        {
            name:"Profile",
            link:"/dashboard/profile",
            icon: <PersonOutlineOutlinedIcon fontSize="small" />,
            event: InvestorActivityEventType.PROFILE_VIEWED
        },
    ];

    useEffect(()=>{
        // Pick the most specific (longest) matching tab path.
        const cur = normalizePath(pathname);
        let bestIndex = -1;
        let bestLen = -1;
        for (let i = 0; i < tabs.length; i++) {
            const link = tabs[i]?.link;
            if (!link) continue;
            if (!isPathMatch(cur, link)) continue;
            const len = normalizePath(link).length;
            if (len > bestLen) {
                bestLen = len;
                bestIndex = i;
            }
        }
        if (bestIndex >= 0) setActiveTab(bestIndex);
     // eslint-disable-next-line
    },[pathname]);

    const handleClickEvent = (event) =>{
        logsService.addLog({
            userId: user?._id,
            event: event
        })
    }

    return(
        <Box
            sx={{
                position:"fixed",
                display:{xs:"block",md:"none"},
                // height: "var(--mobile-bottom-tab-height, 84px)",
                padding: 2,
                paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
                boxSizing: "border-box",
                bgcolor:"#FFF",
                bottom:0,
                left:0,
                width:"100vw",
                boxShadow:"#e1e1e1 0px 0px 5px;",
                zIndex:4
            }}
        >
            <LoginModal handleClose={()=>setShowLogin(false)} open={showLogin} openSign={showSignUp} setShowSignUp={setShowSignUp} showTerms={showTerms} setShowTerms={setShowTerms} />
            <Stack direction={"row"} spacing={1} justifyContent={"space-between"}>
            {
                checkLogin() ? 
                tabs.map((e,i)=>{
                    return(
                        <Box  key={i}
                        onClick={()=>handleClick(i)}
                        sx={{
                            height:"fit-content",
                            flex: 1,
                            minWidth: 0,
                            padding:"10px 8px",
                            bgcolor:activeTab === i ?"primary.light":"",
                            color:activeTab === i ?"primary.main":"",
                            borderRadius:"10px",
                            cursor:"pointer",
                            position:"relative",
                            "&::before":{
                                content:activeTab === i ?"''":'none',
                                position:"absolute",
                                width: "85%",
                                left: "50%",
                                height: "5px",
                                bgcolor: "primary.main",
                                borderRadius: "10px 10px 0px 0px",
                                transform: "translateX(-50%)",
                                bottom: "-16px",
                            }
                        }}>
                            <Stack direction="column" alignItems="center" spacing={0.5} onClick={()=>handleClickEvent(e.event)}>
                                <Box sx={{ lineHeight: 0 }}>
                                    {e.icon}
                                </Box>
                                <Typography
                                    variant="tabBtn"
                                    sx={{
                                        fontSize: 12,
                                        lineHeight: 1,
                                        textAlign: "center",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        width: "100%",
                                    }}
                                >
                                    {e.name}
                                </Typography>
                            </Stack>
                        </Box>
                    );  
                })
                :
                <>
                    <Button onClick={()=>setShowLogin(true)} fullWidth variant="outlined" sx={{color:"#252525",borderColor:"#252525"}}>Login</Button>
                    <Button onClick={()=>{setShowLogin(true);setShowSignUp(true)}} fullWidth variant="contained" sx={{bgcolor:"#252525"}}>Signup</Button>
                </>
            }
        </Stack>
        </Box>
    )
}